import React from 'react';
import Box from '@mui/material/Box';
import { BrowserRouter } from 'react-router-dom';
import Dashboard from './dashboard';
import { HomeContextContextProvider } from '../utils/contexts/homeContext';
import { CookiesProvider } from 'react-cookie';

const HomeContainer = (props) => {

    return (
        <CookiesProvider defaultSetOptions={{ path: '/' }}>
            <Box>
                <BrowserRouter>
                    <Dashboard />
                </BrowserRouter>
            </Box>
        </CookiesProvider>
    );
}

export default function Index() {

    return (
        <HomeContextContextProvider>
            <HomeContainer />
        </HomeContextContextProvider>
    );
}